import { RouteObject } from 'react-router-dom'
import ConsultoresListPage from '@/pages/consultores/ConsultoresListPage'
import ConsultorDetalhePage from '@/pages/consultores/ConsultorDetalhePage'

/**
 * Tela de Consultores (ADMIN) — `docs/PLANO_TELA_CONSULTORES.md`. As páginas fazem a guarda
 * (não-ADMIN vê "sem permissão"); o backend responde 403 de qualquer forma.
 */
const rotasConsultores: RouteObject[] = [
  { path: 'consultores', element: <ConsultoresListPage /> },
  { path: 'consultores/:id', element: <ConsultorDetalhePage /> },
]

export default rotasConsultores
